import React from 'react'
import styles from './MedtechSection1.module.css'
const MedtechSection1 = () => {
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.LeftSection}>
          <h3>
            Bruno Vision Care's Contact Lens for Presbyopia with EDOF Wins 2026 MedTech Breakthrough Award!
          </h3>
          {/* <h4>Best New Technology Solution <br /><span className='diffentFamily'>-</span> Ophthalmology
          </h4> */}
          {/* <p>Deseyne (vifilcon C) Daily Disposable Soft (hydrophilic) Contact Lens for Presbyopia with Extended Depth of Focus (EDOF)</p> */}
        </div>
        <div className={styles.RightSection}>
          <img className={styles.desTopimg} src='/Images/deseyne_product_new.webp' alt='deseyne_product' loading="lazy" decoding="async" />
          <img className={styles.mobImage} src='/Images/Mob_deseyne_product2.png' alt='Mob_deseyne_product' loading="lazy" decoding="async" />
          
        </div>
      </div>

    </div>
  )
}

export default MedtechSection1
